import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

const PromotionCalendarPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <SectionWrapper>
        <div className="p-6">
          <h2 className="text-xl font-semibold mb-4">Calendario de Promociones</h2>
          <p>Visualiza las fechas activas de cada campaña.</p>
        </div>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default PromotionCalendarPage;
